'use client';

import { Sheet, SheetTrigger } from '@musinsa/mds';
import type { CurationSnapDetailGoodsItem } from '@musinsa/services-curator';
import type { FC } from 'react';
import { useState } from 'react';
import { usePreventBodyScroll } from '../../../common/hooks';
import { SnapTaggedGoodsRowSheetTrigger } from './SnapTaggedGoodsRowSheetTrigger';
import { SnapTaggedGoodsSheetContent } from './SnapTaggedGoodsSheetContent';

export interface SnapTaggedGoodsRowSheetProps {
  goodsItems: CurationSnapDetailGoodsItem[];
  invalidateSnapDetail: () => void;
}

export const SnapTaggedGoodsRowSheet: FC<SnapTaggedGoodsRowSheetProps> = ({
  goodsItems,
  invalidateSnapDetail,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const count = goodsItems.length;

  usePreventBodyScroll({ open: isOpen });

  return (
    <Sheet direction="bottom" defaultOpen={false} open={isOpen} onOpenChange={setIsOpen}>
      <SheetTrigger
        asChild
        onClick={(e) => {
          e.stopPropagation();
          setIsOpen(true);
        }}
      >
        <SnapTaggedGoodsRowSheetTrigger aria-label={`태그된 상품 ${count}개 전체보기`} />
      </SheetTrigger>
      <SnapTaggedGoodsSheetContent
        goodsItems={goodsItems}
        invalidateSnapDetail={invalidateSnapDetail}
        onOpenChange={setIsOpen}
      />
    </Sheet>
  );
};
